import { cn } from '@commenda/utils';
import React from 'react';
import { Button } from '../Button';

interface ButtonGroupProps {
    options: Array<{
        value: string;
        label: string;
        icon?: React.ReactNode;
    }>;
    value: string;
    onChange: (value: string) => void;
    className?: string;
}

export function ButtonGroup({ options, value, onChange, className }: ButtonGroupProps) {
    return (
        <div className={cn('inline-flex rounded-lg border border-border-primary bg-bg-primary overflow-clip h-11 divide-x divide-border-primary', className)}>
            {options.map((option) => (
                <Button
                    key={option.value}
                    variant={value === option.value ? 'secondary' : 'tertiary'}
                    className={cn(
                        'flex-1 gap-2 border-none rounded-none txt-small-medium',
                        value === option.value ? 'bg-bg-secondary text-text-primary' : 'bg-bg-primary text-text-disabled'
                    )}
                    onClick={() => onChange(option.value)}
                    size="md"
                >
                    {option.icon}
                    {option.label}
                </Button>
            ))}
        </div>
    );
}